import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Regexs } from '@utils/regex';
import { UserService } from 'src/app/core/services/user.service';
import { CaseService } from 'src/app/modules/case/services/case.service';
import { RolesPermisosService } from 'src/app/services/roles_permisos.service';

@Component({
  selector: 'app-crear-solicitud-alerta',
  templateUrl: './crear-solicitud-alerta.component.html',
  styleUrls: ['./crear-solicitud-alerta.component.scss'],
})
export class CrearSolicitudAlertaComponent implements OnInit {
  form: FormGroup;

  tipo_validaciones = ['Cheque de Gerencia', 'Transferencia Interbancaria'];
  @Input() data: { task: any };

  constructor(
    private fb: FormBuilder,
    public userService: UserService,
    public casesService: CaseService
  ) {}

  especialistas;
  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      especialista: [values ? values.especialista : '', [Validators.required]],
      id_operador: [values ? values.id_operador : '', [Validators.required]],
      id_agencia: [values ? values.id_agencia : '', [Validators.required]],
      descripcion: [values ? values.descripcion : '', [Validators.required]],
    });
    let caseId: any;
    if (typeof this.data.task.case == 'object') {
      caseId = this.data.task.case._id;
    } else if (typeof this.data.task.case == 'string') {
      caseId = this.data.task.case;
    }

    this.casesService.getCase(caseId).subscribe((res: any) => {
      this.userService
        .getUsersByUnityAndPermission(res.caseType.unit)
        .subscribe((response) => {
          this.especialistas = response;
        });
    });
  }

  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
